module.exports = __webpack_public_path__ + "img/pdf.2585ab06.svg";